<template>
    <div>
        <ly-dialog v-model="dialogVisible" :title="dialogTitle" width="640px" :before-close="handleClose">
 <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto" class="form-store">
                <el-form-item label="字典标签：" prop="label">
                    <el-input v-model.trim="formData.label"></el-input>
                </el-form-item>
                <el-form-item label="字典键值：" prop="value">
                    <el-input v-model.trim="formData.value"></el-input>
                </el-form-item>
                <el-form-item label="字典类型：" prop="type">
                    <el-input v-model.trim="formData.type"></el-input>
                </el-form-item>
                <el-form-item label="字典键辅值：" prop="listClass">
                    <el-input v-model.trim="formData.listClass"></el-input>
                </el-form-item>
				<el-form-item label="备注：" prop="remark">
				    <el-input v-model.trim="formData.remark"></el-input>
				</el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label=1>启用</el-radio>
                        <el-radio :label=2>禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序：" prop="sort">
                    <el-input-number v-model="formData.sort" :min="0" :max="999999"></el-input-number>
                </el-form-item>

            </el-form>
            <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave" v-if="dialogTitle!='详情'">确定</el-button>
            </template>
        </ly-dialog>
    </div>
</template>

<script>
    import {deepClone} from '@/utils/util'
    import {apiSystemDictDataAdd,apiDictData,apiSystemDictDataEdit} from '@/api/api'
    import LyDialog from "@/components/dialog/dialog";
    import XEUtils from "xe-utils";
    export default {
        components: {LyDialog},
        emits: ['refreshData'],
        name: "addDepartment",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                dialogTitle:'',
                formData:{
                    parent_id:'',
                    name:'',
                    phone:'',
                    owner:'',
                    status:1,
                    sort:1,
                },
                rules:{
                    // parent_id: [
                    //     {required: true, message: '请选择父级菜单',trigger: 'blur'}
                    // ],
                    name: [
                        {required: true, message: '请输入部门名称',trigger: 'blur'}
                    ],
                    // phone: [
                    //     {required: true, message: '请输入联系电话',trigger: 'blur'}
                    // ],
                    // owner: [
                    //     {required: true, message: '请输入负责人',trigger: 'blur'}
                    // ],
                    status: [
                        {required: 1, message: '请选择状态',trigger: 'blur'}
                    ],
                    // sort: [
                    //     {required: true, message: '请输入排序',trigger: 'blur'}
                    // ],
                },
                options: [
                    {
                        id: 0,
                        name: '根部门'
                    }
                ]
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
                this.formData = {
                    parent_id:'',
                    name:'',
                    phone:'',
                    owner:'',
                    status:1,
                    sort:1,
                }
            },
            addDepartmentFn(item,flag) {
                this.dialogVisible=true
                this.dialogTitle=flag
                this.options=[]
                if(item){
                    this.formData = deepClone(item)
                }
                this.getapiSystemDept()
            },
            loadChild(treeNode, resolve){
                if(treeNode.level == 0){
                    return resolve([])
                }
                var params = {
                    lazy:true,
                    parent_id:treeNode.data.id,
                    page:1,
                    limit:999
                }
                apiDictData(params).then(async res => {
                     if(res.code == 2000) {
                         resolve(res.data)
                     }else {
                         this.$message.warning(res.msg)
                     }
                })
            },
            submitData() {
                let param = {
                    ...this.formData
                }
                this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if( typeof this.formData.parent== 'object') {
                            param.parent = this.formData.parent ?  this.formData.parent[this.formData.parent.length-1] : ''
                        }
                        if(this.dialogTitle=="新增"){
                            apiSystemDictDataAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code == 2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData',param.parent)
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            apiSystemDictDataEdit(this.formData).then(res=>{
                                this.loadingSave=false
                                if(res.code == 2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData',param.parent)
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }
                })
            },
            getapiSystemDept() {
                var params = {
                    page:1,
                    limit:999
                }
                apiDictData(params).then(res=>{
                    if(res.code == 2000) {
                        this.options = XEUtils.toArrayTree(res.data, { parentKey: 'parent_id' })
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }
        }
    }
</script>

